export const Currencies = [
    {
        value: 'gbp',
        text: "GBP",
        icon: '£',
        rate: 1
    },
    {
        value: 'usd',
        text: "USD",
        icon: '$',
        rate: 1.39
    },
    {
        value: 'eur',
        text: "EUR",
        icon: '€',
        rate: 1.17
    },
    {
        value: 'aed',
        text: "AED",
        icon: 'AED',
        rate: 4.98
    },
    {
        value: 'cad',
        text: "CAD",
        icon: 'CAD',
        rate: 1.86
    }
];
